// extracted by mini-css-extract-plugin
export default {"header":"CardHeader_header__D8k1C"};